const QrScanner = require('qr-scanner');

export class wtpScanner {
    private qrScanner: any;
    private options: QrScannerOptions;

    detectWebcam(callback: (result: boolean) => void) {
        let md = navigator.mediaDevices;
        if (!md || !md.enumerateDevices) return callback(false);
        md.enumerateDevices().then((devices) => {
            callback(devices.some((device) => { return 'videoinput' === device.kind }));
        });
    }

    initQrCodeScanner(options: QrScannerOptions) {
        this.options = options;
        this.detectWebcam((hasWebcam) => {
            if (!hasWebcam) {
                return;
            }
            this.options.$activationButton.removeClass('d-none').addClass('d-block');

            this.qrScanner = new QrScanner(options.videoElem, (result) => {
                let wtpMatch = result.match('[A-Z0-9]{8}\-[A-Z0-9]{3}\-[A-Z0-9]{3}');
                if (wtpMatch.length > 0) {
                    this.options.resultTarget.value = wtpMatch[0];
                    this.options.$modal.modal('hide');
                }
            });

            options.$modal.on('hidden.bs.modal', (e) => {
                this.qrScanner.stop();
            });

            this.options.$activationButton.find('button').click(e => {
                this.startQrCodeScan();
            });
        });
    }

    startQrCodeScan() {
        this.qrScanner.start();
        this.options.$modal.modal('show');
    }
}

export interface QrScannerOptions {
    videoElem: HTMLVideoElement;
    resultTarget: HTMLInputElement;
    $modal: JQuery<HTMLElement>;
    $activationButton: JQuery<HTMLElement>;
}